import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Header from "components/Header/Header.js";
import TextField from '@material-ui/core/TextField';
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import ContactUs from "components/ContactUs/index.js";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";
import Link from '@material-ui/core/Link';
import styles from "assets/jss/material-kit-react/views/contactus.js";

const useStyles = makeStyles(styles);

export default function ContactUsMainPage(props) {
    const classes = useStyles();

    const { ...rest } = props;
    
    return (
        <div>
            <Header
                color="transparent"
                brand="Material Kit React"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 200,
                    color: "white"
                }}
                {...rest}
            />
            <Parallax small filter image={require("assets/img/bg2.jpg")} />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div>
                    <div className={classes.container}>
                        <GridContainer justify="center" className={classes.box}>
                            <GridItem xs={12} sm={12} md={8}>
                                <div className={classes.description}>                                    <div >
                                        <h3 className={classes.title}>تماس با ما</h3>
                                        <div className={classes.description}>
<p>
آدرس: تهران، مترو شریف، برج آفرینش
</p>
<p>
    شماره تماس: {"   "}
    <Link href="tel:+989112161695 " variant="outlined" >
    ۰۹۱۱۲۱۶۱۶۹۵
      </Link>
</p>
<p>
ایمیل: 	<Link href="mailto:info@sharifcamp.ir" variant="outlined" >
info@sharifcamp.ir
      </Link>
</p>
<div>
<List className={classes.list}>
<ListItem className={classes.listItem}>
        <Tooltip
          id="telegram-tooltip"
          title="در تلگرام با ما در ارتباط باشید"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            href="https://telegram.me/sharifcamp"
            target="_blank"
            color="transparent"
            className={classes.socialLink}
          >
            <i className={classes.socialIcons + " fab fa-telegram"} />
          </Button>
        </Tooltip>
        </ListItem>
      <ListItem className={classes.listItem}>
        <Tooltip
          id="linkedin-tooltip"
          title="از لینکدین ما دیدن کنید"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            href="https://www.linkedin.com/company/sharifcamp/"
            target="_blank"
            className={classes.socialLink}
          >
            <i className={classes.socialIcons + " fab fa-linkedin"} />
          </Button>
        </Tooltip>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-tooltip"
          title="ما را در اینستاگرام دنبال کنید"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            href="https://www.instagram.com/sharifcamp"
            target="_blank"
            className={classes.socialLink}
          >
            <i className={classes.socialIcons + " fab fa-instagram"} />
          </Button>
        </Tooltip>
      </ListItem>
</List>
</div>
</div>
                                    </div>
                                </div>
                            </GridItem>
                       <GridItem xs={12} sm={12} md={4}>
                         <div  className={classes.div}>
                       <ContactUs></ContactUs>
                       </div>
                       </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
